import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import TextField from '../../../FormLegacy/FormFieldsV2/TextField'
import Avatar from '../../../../Avatar'
import { getAssetLink } from '../../../../helpers/get-asset-link'

const SearchAndSelectWindow = ({ title, isOpen, onClose, showChatType, data, onSelectAction }) => {
  const { t } = useTranslation(['chat'])
  const [search, setSearch] = useState('')

  const filteredData = data
    .filter((userData) => userData.firstName)
    .filter((userData) => {
      const searchTerm = search.toLowerCase()
      const firstName = userData.firstName.toLowerCase()
      const lastName = userData.lastName.toLowerCase()
      return search ? firstName.includes(searchTerm) || lastName.includes(searchTerm) : true
    })

  useEffect(() => {
    setSearch('')
  }, [isOpen])

  if (!isOpen) return null
  return (
    <div className="search-select-window-container">
      <div className="search-select-window-background" />
      <div className="search-select-window-content-container">
        <div className="navbar-part">
          <h1>{title}</h1>
          <div className="close-button" onClick={onClose}>
            <Icon icon="cross" />
          </div>
        </div>
        <TextField
          maxLength="50"
          name={'filter'}
          placeholder={t('chat:searchAndSelectWindow.searchPeople')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="results-part">
          {filteredData.length
            ? filteredData.map((user, idx) => (
                <div key={idx} className="user-option" onClick={() => onSelectAction(user)}>
                  <Avatar size="big">
                    <img
                      src={getAssetLink({ path: 'chitown-avatar/avatar', file: user.avatar })}
                      alt={''}
                    />
                  </Avatar>
                  <div className="row-space">
                    <div>{`${user.firstName} ${user.lastName}`}</div>
                    {showChatType && <div className="chat-type-tag">{user.chatType}</div>}
                  </div>
                </div>
              ))
            : t('chat:searchAndSelectWindow.noResults')}
        </div>
      </div>
    </div>
  )
}

SearchAndSelectWindow.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  showChatType: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.array,
  onSelectAction: PropTypes.func,
}

export default SearchAndSelectWindow
